export class DeleteAddressDTO {
  addressId: string;

  constructor(dto: { addressId: string }) {
    this.addressId = dto.addressId;
  }
}
